import { render, staticRenderFns } from "./PaymentVoucher2.vue?vue&type=template&id=704559d7&scoped=true&"
import script from "./PaymentVoucher2.vue?vue&type=script&lang=js&"
export * from "./PaymentVoucher2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704559d7",
  null
  
)

export default component.exports